import { IProduct } from "../entities/product/types";

export default abstract class AbstractProductDecorator {

  product: IProduct;


  protected constructor(product: IProduct) {
    this.product = product;
  }

  getProduct(): IProduct {
    return this.product;
  }

}
